<template>
  <div class="tooltip-container" ref="targetElement" @mouseover="showTooltip" @mouseleave="hideTooltip">
    <slot name="target" ></slot>
    <!-- We are teleporting here to avoid context clipping -->
    <Teleport to="#app" v-if="visible">
      <div ref="tooltipContent"  class="tooltip-wl fs-12 px-2 py-2 d-none d-lg-inline" :style="{ top: tooltipTop + 'px', left: tooltipLeft + 'px' }">
        <slot name="tooltip-content"></slot>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  props:{
    isDisabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      visible: false,
      tooltipTop:0,
      tooltipLeft:0
    };
  },
  methods: {
    showTooltip() {
      //Tooltip here is taking the target , finding its location on the screen, and placing the tooltip content underneath it.
      //This is done in order to avoid context clipping or unstable behavior due to element context. If other positions are required, this logic will need to be expanded on.
      if(!this.isDisabled){
        const target = this.$refs.targetElement?.children[0];
        const targetBounds = target?.getBoundingClientRect()

        this.visible = true;
        this.$nextTick(() => {
          const tooltipWidth = this.$refs.tooltipContent?.offsetWidth;

          const targetCenterX = targetBounds?.left + targetBounds?.width / 2;

          this.tooltipTop =  targetBounds?.bottom + 10 + window.scrollY;
          this.tooltipLeft = targetCenterX - tooltipWidth / 2 + window.scrollX;
        })
      }
    },
    hideTooltip() {
      this.visible = false;
    },
  },
};
</script>

<style>
.tooltip-container {
  display: inherit;
  position: relative;
}

.tooltip-wl {
  position: absolute;
  background-color: #FFFFFF;
  //transform: translateY(calc(100% + 15px)) translateX(-50%);
  padding: 5px;
  border-radius: 5px;
  z-index: 999;
  box-shadow: 0px -4px 20px 0px rgba(33, 33, 33, 0.16);
  max-width:280px;
  //width:100%;
  font-weight: 400;
  line-height: 125%;
  font-family: Roboto;
}
.tooltip-wl:after{
  content: "";
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #FFFFFF transparent;
}
</style>
